// extracted by mini-css-extract-plugin
module.exports = {"container":"WarningModal_container__SP-Le","headerContent":"WarningModal_headerContent__Bll_t","message":"WarningModal_message__1AgsJ"};